export default __webpack_public_path__ + "static/media/Plantilla-2.98eb5603.png";